<template>
  <transition name="dialog">
    <div class="dialog p_f" v-if="show">
      <div class="p_r">
        <div class="mask p_a" @click="cancel"></div>
        <div
          class="isDialog p_a t_t"
          :style="{ width: width }"
          :class="{ dialog_fixed: buttonFixed, overflow_inherit: overflow }"
        >
          <div class="title t_c p_r">
            <span>{{ title }}</span>
            <div class="close c_p p_a" @click="cancel">╳</div>
          </div>
          <div class="content" :class="{ content_scroll: buttonFixed }">
            <slot name="content"> </slot>
          </div>
          <slot name="foter">
            <div class="foter t_c" :class="{ btn_fixed: buttonFixed }">
              <input type="button" :value="$t('common.Cancel')" @click="cancel" />
              <input type="button" :value="$t('common.Approve')" @click="confirm" />
              <input type="button" :value="$t('common.SendBack')" @click="reject" />
            </div>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BUDDialogArea',
  data () {
    return {
      btnCss: ''
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    confirm () {
      this.$emit('confirm', false)
    },
    reject () {
      this.$emit('reject', false)
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      default: '',
      type: String
    },
    width: {
      default: '40%',
      type: String
    },
    buttonFixed: {
      type: Boolean
    },
    overflow: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.dialog {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 40;
}
.p_r {
  width: 100%;
  height: 100%;
}
.mask {
  width: 100%;
  height: 100%;
  background-color: rgba(36, 36, 36, 0.5);
}
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.5s;
}
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}
.isDialog {
  max-height: 90%;
  overflow-y: auto;
  top: 50%;
  left: 50%;
  padding: 20px 15px;
  border-radius: 8px;
  background-color: white;
  transform: translate(-50%, -50%);
}
.title {
  height: 50px;
  color: #c81b46;
  line-height: 50px;
  border-radius: 6px;
  background-color: #FDF1F4;
  font-size: 18px;
  font-weight: 600;
}
.close {
  top: 50%;
  right: 20px;
  transform: translate(0, -50%);
  width: 22px;
  height: 22px;
  padding: 3px;
  font-size: 18px;
  color: white;
  border-radius: 25px;
  background-color: #dc6f8a;
  line-height: normal;
}
.content {
  width: 96%;
  margin: 20px auto;
}
input {
  width: 120px;
  height: 40px;
  border-radius: 6px;
  color: white;
  border: 1px solid white;
  background-color: #6B853E;
  margin-right: 18px;
}
input:first-child {
  margin-right: 18px;
  color: #c50f3c;
  border: 1px solid #c50f3c;
  background-color: white;
}
input:last-child {
  margin-right: 18px;
  color: white;
  border: 1px solid #c50f3c;
  background-color: #c50f3c;
}
.btn_fixed {
  position: fixed;
  bottom: 3%;
  left: 0;
  width: 100%;
  background-color: white;
}
.content_scroll {
  max-height: 82%;
  overflow-y: scroll;
}
.content_scroll::-webkit-scrollbar {
  width: 3px; /*对垂直流动条有效*/
}
.content_scroll::-webkit-scrollbar-thumb {
  border-radius: 7px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #e8e8e8;
}
.dialog_fixed {
  height: 90%;
}
.overflow_inherit {
  overflow-y: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/BUDDialog.vue